<template>
<div>
  <article v-if="podeResponderFormulario">
    
    <div class="banner" v-if="urlBannerFormulario">        
          <img :src="urlBannerFormulario"  />
    </div>
      
    <div class="header">
      <h4>{{ formulario.titulo }}</h4>
      <p v-html="formulario.descricao">
      </p>      
    </div>
    
    <hr>
    <div :key="`sessao_formulario_${index}`" v-for="(sessao, index) in formulario.sessoesFormulario" id="corpoFormulario" class="sessao-formulario">
      <h5>{{ sessao.nome }}</h5>
      <h6 style="border:1px dashed #ccc; background:coral;padding: 10px;" v-if="isDebug">Total de perguntas: {{ sessao.perguntas.filter(x=>x.visivel).length }}</h6>
      <Perguntas :perguntas="sessao.perguntas.filter(pergunta=>pergunta.visivel)" :key="`perguntas_${index}`" />
    </div>
    <br />
    <div class="row">
      <div class="col" v-if="!podeEnviarFormulario && formularioCarregado">
        <p class="alert alert-danger text-center" v-if="!verificacaoRespostaHabilitado">
          {{msgRespostaObrigatoriaResponderFormulario}}
        </p>

        <div v-if="verificacaoRespostaHabilitado">
            <p class="alert alert-danger text-center text-bold">
              <strong>Verifique abaixo as perguntas que faltam responder!</strong>
            </p>
             <p class="alert alert-danger">
              <ul style="list-style-type: none; margin-top:5px">
                <li v-for="(perguntaSemResposta, index) in perguntasSemRespostasSumario" :key="index" >                  
                    <b>{{perguntaSemResposta.ordemExibicao}}) &nbsp;</b>
                    <span>{{perguntaSemResposta.titulo}}</span>
                    <a :href="`#pergunta_${perguntaSemResposta.perguntaId}`">                     
                      <i class="bi bi-box-arrow-up-left"></i>
                    </a>
                  </li>
              </ul>
             </p>
          </div>
      </div>
    </div>
  <div class="container2">
    <div class="row">
      <div class="col mx-auto text-center">
        <button
          v-if="podeEnviarFormulario"
          @click="responderFormulario"
          class="btn btn-success btn-lg" >
          Enviar Respostas
        </button>
          <button
          v-if="!podeEnviarFormulario"
          @click="verificarRespostas"
          class="btn btn-warning btn-lg" >
          {{labelBotaoVerificarResposta}}
        </button>
        <!-- <button @click="testePosValidacao">
            teste valdiacao
        </button> -->
      </div>
    </div>
  </div>
  </article>
  <p class="alert alert-warning alert-block" v-if="!podeResponderFormulario">
    <b>Verificando informações...</b>
  </p>
  </div>
</template>

<script>
import Perguntas from "../PerguntasComponent/Perguntas";
import formularioService from "../../services/FormularioService";
import notificacaoService from "../../services/Notificacao.service";
import clienteService from "../../services/ClienteService";
import storageService from "../../services/storageService";
import { USER_CONFIG } from "../../config/UserConfig";
import { configuracaoTemaMixin } from "../ConfiguracaoTemaMixin";

export default {
  name: "FormularioPesquisa",
  mixins: [configuracaoTemaMixin],
  mounted() {
    this.verificarPodeResponderFormulario();
    if (!this.formulario) {
      this.redirecionarListaFormulario();
    }
  },
  data() {
    return {
      podeResponderFormulario: false,
    };
  },
  computed: {
    isDebug(){
      return this.$store.state.isDebug;
    },
    formularioAssistido(){
      return this.$store.state.formularioAssistido;
    },
    podeEnviarFormulario() {
      return this.$store.getters.podeEnviarFormulario;
    },
    cliente() {
      const cliente = storageService.getJsonItem(USER_CONFIG.clienteFormulario);
      return cliente;
    },
    pessoa() {

      const pessoa = storageService.getJsonItem(USER_CONFIG.loggedUser);
      return pessoa;
    },
    formularioCarregado() {
      return this.$store.getters.formularioCarregado;
    },
    verificacaoRespostaHabilitado() {
      const { verificacaoRespostaHabilitado } = this.$store.state;

      return verificacaoRespostaHabilitado;
    },
    perguntasSemRespostasSumario() {
      return this.$store.getters.perguntasNaoRespondidasParaSumario;
    },
    msgRespostaObrigatoriaResponderFormulario(){
      return this.$store.getters.configuracaoFormulario.msgRespostaObrigatoriaResponderFormulario;
    },
    labelBotaoVerificarResposta(){
      return this.$store.getters.configuracaoFormulario.labelBotaoVerificarResposta
    },
    msgRespostaEnviadaComSucesso(){
      return this.$store.getters.configuracaoFormulario.msgRespostaEnviadaComSucesso
    }
    //configuracaoFormulario
  },

  methods: {
    redirecionarListaFormulario() {
      const path = `/${this.cliente.apelidoUnico}/area-logada/listagem-formulario`;
      this.$router.push({ path });
    },
     redirecionarFinalizacaoFormularioAssitido() {
      const path = `/finalizar/atendimento-assistido`;
      this.$router.push({ path });
    },
    async verificarPodeResponderFormulario() {
      if (
        this.cliente &&
        this.pessoa &&
        this.cliente.codigoCliente &&
        this.pessoa.pessoaId &&
        this.formulario &&
        this.formulario.formularioId
      ) {
        const { codigoCliente } = this.cliente;
        const { pessoaId } = this.pessoa;
        const { formularioId } = this.formulario;
        this.podeResponderFormulario = await clienteService.podeResponderFormulario(
          codigoCliente,
          formularioId,
          pessoaId
        );
        if (!this.podeResponderFormulario) {
          notificacaoService
            .erro("Formúlario não está disponível para ser respondido.")
            .then(() => this.redirecionarListaFormulario());
        }
      }
    },
    verificarRespostas() {
      this.$store.dispatch("habilitarVerificaoResposta", true);
    },
    async responderFormulario() {
      const { revisarResposta } = this.$store.state.formulario;
      const { podeEnviarFormulario, respostaFormulario } = this.$store.getters;


      //função para envio definitivo das respostas
      const submeterRespostas = async () =>{
         this.$loading(true);
        let notificacaoResult = null;
        try {
          const {
            sucesso,
            interacaoFormularioId,
            erros,
          } = await formularioService.responderFormulario(respostaFormulario);

          if (sucesso) {
            const { codigoCliente } = this.cliente;

            //consultar a pos validação
            const {
              sucesso: sucessoPosValidacao,
              mensagemValidacao,
              entrouNaRegraValidacao,
            } = await formularioService.aplicarPosValidacao(
              codigoCliente,
              interacaoFormularioId
            );

            if (entrouNaRegraValidacao && sucessoPosValidacao) {
              notificacaoResult = notificacaoService.atencao(mensagemValidacao);
            } else if (
              !entrouNaRegraValidacao &&
              sucessoPosValidacao &&
              mensagemValidacao &&
              mensagemValidacao.length
            ) {
              notificacaoResult = notificacaoService.sucesso(mensagemValidacao);
            } else {
              notificacaoResult = notificacaoService.sucesso(this.msgRespostaEnviadaComSucesso);
            }

            notificacaoResult.then((okClick) => {
              if (okClick.value) {

                if(this.formularioAssistido){
                 this.$store.dispatch("descarregarFormulario", 0);
                 this.redirecionarFinalizacaoFormularioAssitido();
                }else {
                   this.$store.dispatch("descarregarFormulario", 0);
                   this.redirecionarListaFormulario();
                }
              }
            });
          } else {
            notificacaoService.erro(erros);
          }
          
        } catch (error) {
          notificacaoService.erro("Todas as perguntas são obrigatórias");
        } finally {
          this.$loading(false);
        }
      }

      if (podeEnviarFormulario) {

        //verificar se o formulário tem que ser revistado a resposta
        //Apresentar um aviso.
        //Por favor revise suas respostaws
        if(revisarResposta){
         const templatePerguntasRespondidas = this.$store.getters.obterTemplateHTMLPerguntasRespondidas;
         const confirmacaoRevisaoResposta =notificacaoService.confirmacao("Por favor revise suas respostas.",templatePerguntasRespondidas);
          confirmacaoRevisaoResposta.then(result=> {
            if(result.value){
              submeterRespostas();
            }
        })
          return;
        }else{
          submeterRespostas();
        }


      } else {
        notificacaoService.atencao("Envio do formulário indisponível");
      }
    }
  },
  props: ["formulario"],
  components: { Perguntas },
};
</script>

<style scoped>
article {
  display: flex;
  flex-direction: column;
}

.banner img {  
  border: 1px solid #ccc;  
  border-radius: 5px;
  background-color: #fff;
  margin-bottom: 10px;
  max-width: 100%;
}

.header {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  background-color: #fff;
  margin-bottom: 10px;
}
.sessao-formulario {
  border: 1px solid #ccc;
  padding: 10px;
  background-color: #fff;
  margin-bottom: 1vh;
  border-radius: 5px;
}
a.nostyle:link {
    text-decoration: inherit;
    color: inherit;
    cursor: pointer;
}

a.nostyle:visited {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Formularios/FormularioPesquisa.vue